import AppointmentIcon from "~/assets/empty-state-icons/appointment-icon.png"
import DiagnosisIcon from "~/assets/empty-state-icons/diagnosis-icon.png"
import DiagnosisIcon2 from "~/assets/empty-state-icons/diagnosis-icon.png"
import PrescriptionIcon from "~/assets/empty-state-icons/prescription-icon.png"

export default function EmptyState ({title,message,type}:{title:string,message:string,type:string}){
  return (<div className="w-full">
    <div className="flex flex-col gap-[16px]  px-[16px] items-center w-full justify-center h-full bg-[#F1F4F9] rounded-[12px] py-[32px]">
      <div className="flex items-center justify-center">
        {type === "appointment" && <img src={AppointmentIcon} alt="appointment" className="w-[49px] h-[49px]" />}
        {type === "doctors_note" && <img src={AppointmentIcon} alt="appointment" className="w-[49px] h-[49px]" />}
        {type === "diagnosis" && <img src={DiagnosisIcon} alt="diagnosis" className="w-[49px] h-[49px]" />}
        {type === "prescription" && <img src={PrescriptionIcon} alt="prescription" className="w-[49px] h-[49px]" />}
        {type === "diagnosis2" && <img src={DiagnosisIcon2} alt="diagnosis2" className="w-[49px] h-[49px]" />}
      </div>
      <div className="flex flex-col gap-[8px] items-center text-center justify-center">
      <h1 className="text-[#1A202C] text-[16px] font-medium leading-[137%] tracking-[-1%]">{title}</h1> 
      <p className="text-[#464B55] text-[14px] leading-[140%] w-[80%] font-normal tracking-[-1%]">{message}</p>
      </div>
    </div>
    </div>
  )
}